import { Skeleton, Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';

function ChartLoading() {
  return (
    <Spin spinning indicator={<LoadingOutlined spin />}>
      <Skeleton active />
    </Spin>
  );
}

export default ChartLoading;
